import { render, staticRenderFns } from "./PaquetesCRUD.vue?vue&type=template&id=7cdeafff&scoped=true"
import script from "./PaquetesCRUD.vue?vue&type=script&lang=js"
export * from "./PaquetesCRUD.vue?vue&type=script&lang=js"
import style0 from "./PaquetesCRUD.vue?vue&type=style&index=0&id=7cdeafff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdeafff",
  null
  
)

export default component.exports